<template>
  <v-list-item v-if="listItem" @click="emitEvent">
    <v-list-item-icon>
      <v-icon>{{ icon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-subtitle class="wrap-normal"> {{ listItemText }}</v-list-item-subtitle>
  </v-list-item>

  <icon-text-btn v-else @onClick="emitEvent" :icon="icon" :text="text" :iconColor="color" small :hint="hint"> </icon-text-btn>
</template>

<script>
import common from '@/mixins/common';
import IconTextBtn from './IconTextBtn.vue';
import readService from '@/services/readService';
import eventBus from '@/common/eventBus';

export default {
  name: 'ToggleReadButton',
  mixins: [common],
  components: {
    IconTextBtn,
  },
  props: {
    listItem: { type: Boolean, default: false },
    iconOnly: { type: Boolean, default: false },
    color: String,

    type: { type: String, default: 'read' }, // read or watch
    item: Object, //item with item._userState.dateread and item._moduleId properties
  },

  beforeDestroy() {
    eventBus.removeEventHandler(eventBus.createFileChangedEventType(this.item));
  },
  data() {
    return {
      isRead: readService.isRead(this.item),
    };
  },
  computed: {
    icon() {
      return this.isRead ? this.mx_icons.read : this.mx_icons.unread;
    },

    listItemText() {
      if (this.type === 'read') {
        return this.isRead ? this.$t('read.markAsUnread') : this.$t('unread.markAsRead');
      } else {
        return this.isRead ? this.$t('watched.markAsUnwatched') : this.$t('unwatched.markAsWatched');
      }
    },
    text() {
      if (this.type === 'read') {
        return this.isRead ? this.$t('read') : this.$t('unread');
      } else {
        return this.isRead ? this.$t('watched') : this.$t('unwatched');
      }
    },
    hint() {
      if (this.type === 'read') {
        return this.isRead ? this.$t('set_unread') : this.$t('set_read');
      } else {
        return this.isRead ? this.$t('set_unwatched') : this.$t('set_watched');
      }
    },
  },
  methods: {
    eventHandler(eventType, eventObj) {
      // console.debug("received event", eventType, JSON.stringify(eventObj, null, 2))

      this.isRead = readService.isRead(eventObj.item);
    },
    init(newValue, oldValue) {
      // console.debug("init file", this.item._moduleId, this.item.id)
      // If the new file references not the same object as before, we need to register the eventHandler
      // If the oldValue was not null, we need to remove the old handler
      if (newValue !== oldValue) {
        if (oldValue) {
          eventBus.removeEventHandler(eventBus.createReadStateEventType(oldValue));
        }
        // console.debug("addEventHandler for", eventBus.createFileChangedEventType(this.item))
        eventBus.addEventHandler(eventBus.createReadStateEventType(this.item), this.eventHandler);
      }

      if (newValue) {
        this.isRead = readService.isRead(this.item);
      }
    },
    emitEvent() {
      if (this.isRead === false) {
        console.debug('emit markAsRead');
        this.markAsRead();
        //this.$emit('markAsRead');
      } else {
        console.debug('emit markAsUnread');
        this.markAsUnread();
        // this.$emit('markAsUnread');
      }
      this.isRead = readService.isRead(this.item);
      // console.debug("publish FileChanged Event", this.item._moduleId, this.item.id)
      eventBus.publish({
        selfHandler: this.eventHandler,
        eventType: eventBus.createReadStateEventType(this.item),
        eventObj: { msg: 'read state changed', item: this.item },
      });
    },
    markAsRead() {
      let sendboxTitle = this.$t('action.read.msg', { title: this.item.title });
      let snackbarText = this.$t('action.document.read');
      this.$store.dispatch(`sendbox/markAsRead2`, { item: this.item, sendboxTitle, snackbarText, immediate: true }, { root: true });
    },

    markAsUnread() {
      let sendboxTitle = this.$t('action.unread.msg', { title: this.item.title });
      let snackbarText = this.$t('action.document.unread');
      this.$store.dispatch(`sendbox/markAsUnread2`, { item: this.item, sendboxTitle, snackbarText }, { root: true });
    },
  },
  watch: {
    // needs to watch for changed items because the component is not aware of changed items otherwise (e.g another file is attached)

    item: {
      handler(newValue, oldValue) {
        // console.debug("ToggleReadButton item changed id", newValue._moduleId, newValue.id)
        this.init(newValue, oldValue);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
